import React, { Component } from 'react';

import Divider from 'material-ui/Divider';
import Clear from 'material-ui/svg-icons/content/clear';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreHorizIcon from 'material-ui/svg-icons/navigation/more-horiz';
import { List, ListItem } from 'material-ui/List';

import moment from 'moment';

import * as Colors from '../../../styles/colors';
import Utils from '../../../services/utils';
import MarkerText from '../../../components/MarkerText';

function AssignmentDetailActionBar(props) {

  return (
    <div className='action-bar'>
      <IconButton onClick={props.onActionClose}>
        <Clear color={Colors.peterRiver} />
      </IconButton>
      <IconMenu
        animated={false}
        desktop={true}
        iconButtonElement={<IconButton><MoreHorizIcon color={Colors.peterRiver}/></IconButton>}
        anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
        targetOrigin={{horizontal: 'left', vertical: 'top'}}>
      <MenuItem primaryText="Edit" onClick={() => props.onActionEdit(props.item)} />
      <MenuItem primaryText="Delete" onClick={() => props.onActionDelete(props.item)} />
    </IconMenu>
    </div>
  );

}

function AlarmItemDetail(props) {
  const alarm = props.alarm;

  var alarmIdentifier = "";
  if (alarm !== null && alarm !== undefined)  {
    const offsetIdentifier = Utils.alarmOffsetIdentifier(alarm.get('referenceDayOffset'))
    const formattedFireDate = moment(alarm.get('fireDate')).format('LT')
    
    alarmIdentifier = offsetIdentifier + " at " + formattedFireDate
  } else {
    alarmIdentifier = "None"
  }
  
  return (
    <p className='detail-item__title'>{alarmIdentifier}</p>
  );
}

function TaskList(props) {
  const tasks = props.tasks || [];

  return (
    <List>
     { tasks.map((task) =>
      <ListItem
        key={task.id}
        value={task.id}
        leftCheckbox={(
          <Checkbox 
            checked={task.get('completed') === 1} 
            onClick={() => props.onProgressChange(task)} 
            style={{width: 'auto'}} />
        )}
        primaryText={task.get('text')}
        secondaryText={task.get('completed') ? moment(task.get('completedAt')).format('ddd, l') : null} />
     )}
    </List>
  );

}

class AssignmentDetail extends Component {

  handleTaskProgressChange = (task) => {
    const completed = task.get('completed') === 1 ? 0 : 1;
    task.set('completed', completed);
    if (completed === 1) {
      task.set('completedAt', new Date());  
    } else {
      task.unset('completedAt');
    }
    
    const that = this, a = this.props.item;
    task.save().then(
      function(obj) {
        const index = a.get('tasks').findIndex((t) => {
          return t.id === obj.id;
        });

        if (index !== -1) {
          a.get('tasks')[index] = obj;
          that.forceUpdate();
        }
      },
      function(err) {
        console.log("Failed to save task with error " + err);
      }
    );
  }

  render() {
    const item = this.props.item;
    const tasks = item.get('tasks') || [];
    const showActionBar = this.props.showActionBar != null ? this.props.showActionBar : true;
    
    return (
      <div>
        { 
          item != null ? (
            <div>
              { showActionBar ? (
                <AssignmentDetailActionBar 
                  item={item}
                  onActionClose={this.props.onRequestClose}
                  onActionEdit={this.props.onRequestEdit}
                  onActionDelete={this.props.onRequestDelete} />
              ) : null }

              <div className='detail-header-box'>
                <Checkbox
                  onCheck={(e) => this.props.onProgressChange(e, item)}
                  checked={item.get('completed') === 1}
                  style={{width: 'auto'}}
                />
                <h2>{ item.get('title') }</h2>
              </div>
              <p>{ item.get('text') }</p>
              <Divider />
              <div className='detail-item'>
                <p className='floating-label'>Course</p>
                { item.get('course') != null ? (
                  <MarkerText 
                    className='detail-item__title'
                    text={item.get('course').get('title')} 
                    color={item.get('course').get('color')} 
                  />)
                  : null 
                }
              </div>
              <div className='detail-item'>
                <p className='floating-label'>Due At</p>
                <p className='detail-item__title'>{ moment(item.get('dueAt')).format('ddd, l') }</p>
              </div>
              <div className='detail-item'>
                <p className='floating-label'>Alarm</p>
                <AlarmItemDetail alarm={item.get('alarm')} />
              </div>
              <Divider />
              <div className='detail-item-multiple'>
                <div className='detail-item detail-item__multiple--leading'>
                  <p className='floating-label'>Planned At</p>
                  <p className='detail-item__title'>{ moment(item.get('plannedAt')).format('ddd, l') }</p>
                </div>
                <div className='detail-item'>
                  <p className='floating-label'>Effort</p>
                  <p className='detail-item__title'>{ item.get('effort') }</p>
                </div>
              </div>
              <Divider />
              <div className='detail-item'>
                <p className='floating-label'>Tasks</p>
                <TaskList onProgressChange={this.handleTaskProgressChange} tasks={item.get('tasks')} />
              </div>
            </div>
          ) : (
            null
          )
        }
      </div>
    );
  }

}

export default AssignmentDetail;


// WEBPACK FOOTER //
// ./src/scenes/Assignments/components/AssignmentDetail.js